<ph-card heading="Mark as paid" flat [formGroup]="markAsPaidFormGroup">
    <ph-field>
        <ph-label required>How would you like to mark this invoice as paid?</ph-label>
        <ph-radio-group aria-label="Match with an existing transaction" [items]="[recordTypeItems[0]]"
                        [value]="recordTypeValueFor(PaymentRecordType.MATCH)"
                        (ph-change)="selectRecordType($event.detail)"></ph-radio-group>
    </ph-field>

    <ph-field *ngIf="markAsPaidFormGroup.get('paymentRecordType')?.value === PaymentRecordType.MATCH">
        <ph-label required>Select transaction</ph-label>
        <ph-select formControlName="existingTransactionToMatch" ngDefaultControl [items]="transactionItems"
                   placeholder="Select transaction"></ph-select>
        <ph-hint has-error
            *ngIf="markAsPaidFormGroup.get('existingTransactionToMatch').touched &&
          markAsPaidFormGroup.get('existingTransactionToMatch').hasError('required')">
            Please select a transaction
        </ph-hint>
    </ph-field>

    <ph-field>
        <ph-radio-group aria-label="Create a new payment record" [items]="[recordTypeItems[1]]"
                        [value]="recordTypeValueFor(PaymentRecordType.CREATE)"
                        (ph-change)="selectRecordType($event.detail)"></ph-radio-group>
    </ph-field>

    <ng-container *ngIf="markAsPaidFormGroup.get('paymentRecordType')?.value === PaymentRecordType.CREATE">
        <ph-field>
            <ph-label required>Payment bank account</ph-label>
            <app-bank-account-selector
                [formGroup]="markAsPaidFormGroup"
                controlName="bankAccountForTransaction"
                [accountId]="localPayable?.payableUnifiedBankAccountId"
            >
            </app-bank-account-selector>
            <ph-hint has-error
                *ngIf="markAsPaidFormGroup.get('bankAccountForTransaction').touched &&
              markAsPaidFormGroup.get('bankAccountForTransaction').hasError('required')">
                Bank account is required
            </ph-hint>
        </ph-field>

        <ph-field>
            <ph-label required>Payment date</ph-label>
            <ph-date-input formControlName="paymentDate" ngDefaultControl></ph-date-input>
            <ph-hint has-error
                *ngIf="markAsPaidFormGroup.get('paymentDate').touched &&
                markAsPaidFormGroup.get('paymentDate').hasError('required')"
            >
                Payment date is required
            </ph-hint>
        </ph-field>

        <ph-field>
            <ph-label sub="(optional)">Memo</ph-label>
            <ph-textarea formControlName="paymentMemo" ngDefaultControl rows="2"
                         placeholder="Other invoice details"></ph-textarea>
        </ph-field>
    </ng-container>
</ph-card>
